/**
 * KCIS Module 1 — Identity & Wellness Alignment Assessment API client.
 *
 * Public endpoints sit under `/api/identity/*`; admin endpoints reuse the
 * shared KCIS admin JWT through axios baseURL + Bearer header.
 */
import axios from "axios";
import { adminAuth } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;
const PUBLIC = `${BASE}/api/identity`;
const ADMIN = `${BASE}/api/identity/admin`;

const publicClient = axios.create({ baseURL: PUBLIC });
const adminClient = axios.create({ baseURL: ADMIN });

adminClient.interceptors.request.use((config) => {
  const t = adminAuth.getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const identityApi = {
  // public
  options: () => publicClient.get("/options"),
  bookingLinks: () => publicClient.get("/booking-links"),
  emailCapture: (payload) => publicClient.post("/email-capture", payload),
  submit: (payload) => publicClient.post("/assessments", payload),
  partial: (payload) => publicClient.post("/assessments/partial", payload),
  getResult: (submissionId, email) =>
    publicClient.get(`/assessments/${submissionId}`, { params: { email } }),
  pdfUrl: (submissionId, email) =>
    `${PUBLIC}/assessments/${submissionId}/pdf?email=${encodeURIComponent(email)}`,
  bookingClick: (payload) => publicClient.post("/booking-clicks", payload),

  // admin (super_admin JWT)
  adminHealth: () => adminClient.get("/health"),
  adminList: (params) => adminClient.get("/submissions", { params }),
  adminDetail: (id) => adminClient.get(`/submissions/${id}`),
  adminPdfUrl: (id) => `${ADMIN}/submissions/${id}/pdf`,
  adminResendEmail: (id) => adminClient.post(`/submissions/${id}/resend-email`),
  adminEmailCaptures: (params) => adminClient.get("/email-captures", { params }),
  adminBookingClicks: (params) => adminClient.get("/booking-clicks", { params }),
  adminBookingLinks: () => adminClient.get("/booking-links"),
  adminUpdateBookingLinks: (links) => adminClient.put("/booking-links", { links }),
  adminFunnel: () => adminClient.get("/analytics/funnel"),
};
